import { plat, getCurrPlat } from "@utils/plat";

/**
 * 引入模块
 * @param {context} importContext 上传模块
 * @returns {Record<string, string>} 模块对象
 */
function importAll(importContext) {
    // 文件路径
    const filePaths = importContext.keys();
    let modules = {};
    // 遍历
    for (const filePath of filePaths) {
        // 引入
        const importModules = importContext(filePath);
        // 拼接
        modules = { ...modules, ...importModules };
    }
    // 导出
    return modules;
}
/**
 * 拦截器
 * @param {Record<string, unkown>} modules 模块对象
 * @param {Record<string, unkown>} options 配置对象
 */
export function interceptor(modules, options) {
    // 遍历
    for (const key in options) {
        // 获取值
        const value = modules[key];
        // 获取options值
        const optionsValue = options[key];
        // 不存在,并且options配置的不是方法则跳过
        if (typeof optionsValue !== "function") continue;
        let handler;
        // 方法
        if (typeof value === "function") handler = (...args) => optionsValue(value(...args), ...args);
        // value不存在
        else if (!value) handler = (...args) => optionsValue(value, ...args);
        // 非方法
        else optionsValue(value);
        // 替换
        modules[key] = handler;
    }

    return modules;
}
/**
 * 拦截器引入
 * @param {string} context 目录
 * @returns
 */
const interceptorImport = (context, options) => interceptor(importAll(context), options);
/**
 * 获取对应平台模块
 * @param {Record<string, (value: any) => any} options 拦截器配置
 * @returns
 */
export function getPlatformModule(options) {
    // 引入所有js模块
    const app = interceptorImport(require.context("./app", false, /\.js$/), options);
    const wechat = interceptorImport(require.context("./wechat", false, /\.js$/), options);
    // 当前渠道id
    const currPlatId = getCurrPlat().id;
    // 判断环境导出
    if (currPlatId === plat.app.id) return app;
    else return wechat;
}
